export default __webpack_public_path__ + "static/media/Vercauteren.24fb4851.png";